import { Routes } from '@angular/router';
import { AppDeciderComponent } from '../layouts/app-decider/app-decider.component';
import { canActivateAuthorization } from '../security/authorization.guard';
import { PermissionResponse } from '../core/base-api';
import { PersonZpvRoutes } from './person-zpv/person-zpv.routes';
import { PersonstammRoutes } from './person-stamm/personstamm.routes';
import { GemeindeRoutes } from './gemeinde/gemeinde.routes';
import PermissionsEnum = PermissionResponse.PermissionsEnum;

export const StammdatenRoutes: Routes = [
  {
    path: 'stammdaten',
    component: AppDeciderComponent,
    canActivate: [canActivateAuthorization],
    data: {
      permissions: [PermissionsEnum.LOGIN, PermissionsEnum.ICP_AUTHORIZED, PermissionsEnum.ANONYM]
    },
    children: [...PersonZpvRoutes, ...PersonstammRoutes, ...GemeindeRoutes]
  }
];
